import React, { useState, useContext, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axios from "../../../../../axios/index";
import { useLocation } from "react-router-dom";
import PersianNumberToString from "persian-number-tostring";

// context
import { UserContext } from "../../../../Context/UserContextProvider";

//Styles
import styles from "../../../DashboardReuseAbleComponents/AddNewFile.module.css";
import Dstyles from "../../../DashboardFileManagement/DashboardFileManagement.module.css";
import "react-toastify/dist/ReactToastify.css";

// Re Useable Components
import AddNewFileDropdown from "../../../DashboardReuseAbleComponents/AddNewFiles/AddNewFileDropdown";
import DashboardHeader from "../../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../../DashboardReuseAbleComponents/DashboardSideMenu";
import { editCardValidate } from "./editCardValidate";
import { removeCommas } from "@persian-tools/persian-tools";
import Images from "./Images";
import { Editor } from "@tinymce/tinymce-react";
import SelectFacilitiesModal from "../../../DashboardReuseAbleComponents/AddNewFiles/SelectFacilitiesModal";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ShowProfileModal from "../ShowProfileModal";
import NewFilesConsultantSelect from "../../../DashboardReuseAbleComponents/AddNewFiles/NewFilesConsultantSelect";
import Checkbox from "@mui/material/Checkbox";

//images
import arrowIcon from "../../../../../assets/img/DashboardICons/ArrowRounded.svg";
import addIcon from "../../../../../assets/img/DashboardICons/AddIconBlue.svg";
import PlacesInput from "../../../DashboardReuseAbleComponents/AddNewFiles/PlacesInput";
import CardDetail from "../CardDetail";
import { Helmet } from "react-helmet";

const EditCard = props => {
  const { state } = useLocation();
  const { userToken, userData, permissions } = useContext(UserContext);
  const userRole = permissions?.find(item => item === 15) === 15 ? "IsSuperUser" : "IsConsultant";
  const history = useHistory();
  const [modalShow2, setModalShow2] = useState(false);
  const [modalShow3, setModalShow3] = useState(false);
  const [errors, setErrors] = useState({});
  const [loadedImages, setLoadeImages] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);
  const [editedData, setEditedData] = useState();
  const [addedFacilitiesID, setAddedFacilitiesID] = useState([]);
  const [facilitiData, setFacilitiData] = useState();
  const [parkingCount, setParkingCount] = useState(0);
  const [addedFacilities, setAddedFacilities] = useState([]);
  const [images, setImages] = useState();

  const description = useRef(null);
  const [inputValues, setInputValues] = useState([{ fullName: "", phoneNumber: "", responsibility: "" }]);

  let [editId, setEditId] = useState(0);

  const [fileData, setFileData] = useState({
    slug: "",
    title: "",
    meter: 0,
    meterBase: 0,
    meterBalkony: 0,
    meterGate: 0,
    storage: "", //commercial storage
    ceilingHeight: 0,
    totalFloors: "",
    pumpCount: "",
    walkawayWidth: "",
    landWidth: "",
    landHeight: "",
    address: "",
    mortgage: "",
    rent: "",
    totalPrice: "",
    metrajPrice: "",
    facilities: "",
    description: "",
    hidden: false,
    nofloor: false,
    presale: false,
    userPhone: "",
    shortAddress: "",
    city: "",
    place: "",
    year: "",
    room: 0,
    floor: "",
    fileFound: "",
    unitsNumber: "",
    fileConsultant: [],
    hasExchange: false,
    exchangeData: "",
    seoTitle: "",
    seoDescription: "",
    seoKeywords: "",
    seoIndexPage: false,
    seoCanonical: "",
    seoSchema: "",
    region: "",
  });

  const handleAddInputs = () => {
    setInputValues([...inputValues, { fullName: "", phoneNumber: "", responsibility: "" }]);
  };

  const handleRemoveInputs = () => {
    setInputValues(inputValues.slice(0, -1));
  };

  const removeSymbolNumberHandler = e => {
    const removeSymbolNumber = ["e", "E", ".", "-"];

    if (removeSymbolNumber.includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const updatedInputValues = [...inputValues];
    updatedInputValues[index][name] = value;
    setInputValues(updatedInputValues);
  };

  useEffect(() => {
    const getData = async () => {
      const getEditData = await axios.get(`Estate/bySlugAdmin/${state.state.slug}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      const editedData = getEditData.data.data;
      setEditId(editedData.categoryId);
      const getApiData = await axios.get(`Specification/GetList?categoryId=${editedData.categoryId}&subCategoryId=${editedData.subCategoryId}`, {
        headers: { authorization: "Bearer " + userToken },
      });

      setEditedData(editedData);
      setFileData(prev => {
        return {
          ...prev,
          hasExchange: editedData.exchangeDescription != null || editedData.exchangeDescription != undefined,
          meterBalkony: editedData.meterageBalkony,
          meterGate: editedData.meterageGate,
          storage: editedData.commercialStorage,
          ceilingHeight: editedData.ceilingHeight,
          pumpCount: editedData.pumpCount,
          walkawayWidth: editedData.walkawayWidth,
          landWidth: editedData.landWidth,
          landHeight: editedData.landHeight,
          meterBase: editedData.meterageBase,
          totalFloors: editedData.totalFloors,
          title: editedData.title,
          meter: editedData.meterage,
          address: editedData.address.fullAddress,
          shortAddress: editedData.address.shortAddress,
          mortgage: editedData.mortgagePrice,
          rent: editedData.rentPrice,
          totalPrice: editedData.totalPrice,
          metrajPrice: editedData.meteragePrice,
          description: editedData.description,
          saleOrRent: editedData.rentPrice === null || editedData.rentPrice === 0 ? "sale" : "rent",
          city: editedData.address.city,
          place: editedData.address.zone,
          year: editedData.constructionYear,
          room: editedData.roomCount,
          floor: editedData.floor,
          fileFound: editedData.searchType,
          exchangeData: editedData.exchangeDescription,
          unitsNumber: editedData?.unitsNumber,
          fileConsultantID: editedData?.userId,
          seoTitle: editedData.seoData.metaTitle,
          seoDescription: editedData.seoData.metaDescription,
          seoKeywords: editedData.seoData.metaKeyWords,
          seoIndexPage: editedData.seoData.indexPage,
          seoCanonical: editedData.seoData.canonical,
          seoSchema: editedData.seoData.schema,
          region: editedData.estateRegion,
          link: editedData.otherSiteUrl,
          slug: editedData.slug,
        };
      });
      setInputValues(editedData?.infos);
      setLoadeImages(editedData.images);

      var customeSpecifications = editedData.facilities.split(",");
      setAddedFacilities(customeSpecifications);
      setFacilitiData(getApiData.data.data);
      const filterdObjects = getApiData.data.data.filter(obj => {
        return customeSpecifications.includes(obj.title);
      });
      setAddedFacilitiesID(filterdObjects.map(item => item.id));
      setParkingCount(parseInt(editedData?.customSpecifications[0]?.value) || 0);

      setIsLoading(false);
    };
    getData();
  }, [state, userToken]);

  useEffect(() => {
    setErrors(editCardValidate(fileData, images, loadedImages, props.userAdd ? true : false));
  }, [fileData, images, loadedImages, props.userAdd]);

  const shopCategories = [304, 280];
  const hotelCategories = [278, 291];
  const gasStationCategories = [309, 316];
  const landCategories = [273, 277, 281, 284, 287, 302, 305, 308, 312, 315, 517];
  const industrialCategories = [311, 312, 313, 314, 318, 319, 320, 321];

  const addCommas = num => num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const removeNonNumeric = num => num?.toString().replace(/[^0-9]/g, "");

  let [categories, setCategories] = useState([]);

  useEffect(() => {
    axios
      .get("Category", {
        headers: {
          authorization: "Bearer " + userToken,
        },
      })
      .then(res => {
        setCategories(res.data?.data || []);
      });
  }, []);

  function getCategoryParent() {
    return categories.find(c => c.id == editId)?.parentId;
  }

  useEffect(() => {
    if (editedData?.userId != undefined) {
      if (
        editedData.userId != userData.id &&
        !(permissions?.find(item => item === 19) === 19) &&
        !(permissions?.find(item => item === 15) === 15) &&
        !(permissions?.find(item => item === 3) === 3)
      ) {
        window.location = "/";
      }
    }
  }, [editedData]);

  function getShopsFields() {
    return (
      <>
        <div className="d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap" dir="rtl">
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>متراژ کف مغازه</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      type="number"
                      name="meterBase"
                      value={fileData.meterBase}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>ارتفاع سقف</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      type="number"
                      name="ceilingHeight"
                      value={fileData.ceilingHeight}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>متراژ بالکن</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      type="number"
                      name="meterBalkony"
                      value={fileData.meterBalkony}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap" dir="rtl">
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>متراژ دهنه</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      type="number"
                      name="meterGate"
                      value={fileData.meterGate}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>متراژ کل</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      type="number"
                      name="meter"
                      value={fileData.meter}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>انبار تجاری</div>
                  <label className="position-relative" htmlFor="meter">
                    <input
                      name="storage"
                      value={fileData.storage}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap" dir="rtl">
          <AddNewFileDropdown setDropDownsData={setFileData} floorNumber={fileData.floor} floor userAdd={props.userAdd ? true : false} />
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>تعداد طبقه</div>
                  <label className="position-relative" htmlFor="meter">
                    <input
                      type="number"
                      name="totalFloors"
                      value={fileData.totalFloors}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  function getBaseFields() {}

  function getLandFields() {
    return (
      <>
        <div className="d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap" dir="rtl">
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>متراژ زمین</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      type="number"
                      name="meter"
                      value={fileData.meter}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>متراژ بنا</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      type="number"
                      name="meterBase"
                      value={fileData.meterBase}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap" dir="rtl">
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>عرض ملک</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      type="number"
                      name="landWidth"
                      value={fileData.landWidth}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>عرض گذر</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      type="number"
                      name="walkawayWidth"
                      value={fileData.walkawayWidth}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>طول ملک</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      name="landHeight"
                      value={fileData.landHeight}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  function getGasStationFields() {
    return (
      <>
        <div className="d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap" dir="rtl">
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>متراژ زمین</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      type="number"
                      name="meter"
                      value={fileData.meter}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>متراژ بنا</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      type="number"
                      name="meterBase"
                      value={fileData.meterBase}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>تعداد نازل</div>
                  <label className="position-relative" htmlFor="meter">
                    <input
                      type="number"
                      name="pumpCount"
                      value={fileData.pumpCount}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  function getHotelFields() {
    return (
      <>
        <div className="d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap" dir="rtl">
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>متراژ بنا</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      type="number"
                      name="meterBase"
                      value={fileData.meterBase}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>متراژ زمین</div>
                  <label className="position-relative" htmlFor="meter">
                    <span className={styles.input_left_text}>متر</span>
                    <input
                      type="number"
                      name="meter"
                      value={fileData.meter}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>تعداد اتاق</div>
                  <label className="position-relative" htmlFor="meter">
                    <input
                      type="number"
                      name="room"
                      value={fileData.room}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap" dir="rtl">
          <AddNewFileDropdown setDropDownsData={setFileData} floorNumber={fileData.floor} floor userAdd={props.userAdd ? true : false} />
          <div className="py-2 ms-0">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div className={`mb-3 ${styles.input_header}`}>تعداد طبقه</div>
                  <label className="position-relative" htmlFor="meter">
                    <input
                      type="number"
                      name="totalFloors"
                      value={fileData.totalFloors}
                      onChange={changeHandler}
                      className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                      style={{ textAlign: "right" }}
                      onKeyDown={removeSymbolNumberHandler}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <style>
          {`
                        input {
                            padding: 20px;
                            direction: rtl;
                            text-align: right;
                        }
                    `}
        </style>
      </Helmet>

      <ShowProfileModal show={modalShow3} onHide={() => setModalShow3(false)} />

      <SelectFacilitiesModal
        show={modalShow2}
        onHide={() => setModalShow2(false)}
        addedFacilities={addedFacilities}
        setAddedFacilities={setAddedFacilities}
        facilitiData={facilitiData}
        itemID={facilitiData}
        addedFacilitiesID={addedFacilitiesID}
        setAddedFacilitiesID={setAddedFacilitiesID}
        parkingCount={parkingCount}
        setParkingCount={setParkingCount}
      />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
              />
              <div className={`mt-3 px-0 ${Dstyles.container}`}>
                <DashboardHeader onClick={() => setModalShow3(true)} />

                {/* Rent Type Header start */}
                <div className="py-2">
                  <div className="container-fluid">
                    <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                      <div className="w-100 d-flex align-items-center justify-content-center justify-content-md-start flex-wrap mt-2 mb-2">
                        <a href="#" onClick={history.goBack}>
                          <img className="ms-2 pointer" src={arrowIcon} alt="icon" />
                        </a>
                        <div className={Dstyles.text1}>{editedData?.title}</div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Rent Type Header end */}

                {/* title input start */}
                <div className="py-2">
                  <div className="container-fluid">
                    <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                      <div className="w-100 d-flex justify-content-between align-items-start mb-4">
                        <div className="w-100 d-flex align-items-start justify-content-center flex-column ms-2">
                          <div className={`mb-3 ${styles.input_header}`}>عنوان</div>
                          <input
                            type="text"
                            name="title"
                            value={fileData.title}
                            onChange={changeHandler}
                            className={`w-100 bg-light py-2 pe-3 ${styles.input}`}
                            placeholder="مثلا آپارتمان ۳۰۰ متر تختی"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* title input end */}

                {/* sub menus row1 */}
                <div className="d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap">
                  <AddNewFileDropdown setDropDownsData={setFileData} yearName={fileData.year} year userAdd={props.userAdd ? true : false} />
                  {/*<PlacesInput placeName={fileData.place} setDropDownsData={setFileData} />*/}
                  <AddNewFileDropdown cityName={fileData.city} setDropDownsData={setFileData} city userAdd={props.userAdd ? true : false} />
                </div>
                {/* sub menus row1 */}

                {shopCategories.includes(getCategoryParent()) ? (
                  getShopsFields()
                ) : hotelCategories.includes(getCategoryParent()) ? (
                  getHotelFields()
                ) : gasStationCategories.includes(getCategoryParent()) ? (
                  getGasStationFields()
                ) : landCategories.includes(getCategoryParent()) ? (
                  getLandFields()
                ) : (
                  <></>
                )}

                {/* sub menus row2 */}

                {!shopCategories.includes(getCategoryParent()) &&
                !hotelCategories.includes(getCategoryParent()) &&
                !gasStationCategories.includes(getCategoryParent()) &&
                !landCategories.includes(getCategoryParent()) ? (
                  <>
                    <div className="d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap">
                      <AddNewFileDropdown setDropDownsData={setFileData} floorNumber={fileData.floor} floor userAdd={props.userAdd ? true : false} />
                      <AddNewFileDropdown setDropDownsData={setFileData} roomNumber={fileData.room} room userAdd={props.userAdd ? true : false} />
                      <div className="py-2">
                        <div className="container-fluid">
                          <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                            <div className="d-flex flex-column justify-content-center align-items-start">
                              <div className={`mb-3 ${styles.input_header}`}>متراژ</div>
                              <label className="position-relative" htmlFor="meter">
                                <span className={styles.input_left_text}>متر</span>
                                <input
                                  type="number"
                                  name="meter"
                                  value={fileData.meter}
                                  onChange={changeHandler}
                                  className={`bg-light py-2 ps-5 pe-2 ${styles.input_meter}`}
                                  style={{ textAlign: "right" }}
                                />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="py-2 ms-0">
                      <div className="container-fluid">
                        <div
                          className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${
                            props.userAdd ? "" : "mt-3 me-3"
                          }`}
                          dir="rtl">
                          <div className="d-flex flex-column justify-content-center align-items-start">
                            <div className={`mb-3 ${styles.input_header}`}>تعداد طبقه</div>
                            <label className="position-relative" htmlFor="meter">
                              <input
                                type="number"
                                name="totalFloors"
                                value={fileData.totalFloors}
                                onChange={changeHandler}
                                className={`bg-light py-2 ps-5 pe-2 ${props.userAdd ? styles.input_meter_user : styles.input_meter}`}
                                style={{ textAlign: "right" }}
                                onKeyDown={removeSymbolNumberHandler}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
                {/* sub menus row2 */}

                {/* sub menus row3 */}
                <AddNewFileDropdown regionName={fileData.region} setDropDownsData={setFileData} region userAdd={props.userAdd ? true : false} />
                {/* sub menus row3 */}

                {/* address */}
                <div className="py-2 mb-3">
                  <div className="container-fluid">
                    <div className="d-flex justify-content-md-start justify-content-center flex-wrap align-items-end mt-3 me-3" dir="rtl">
                      <div className={`d-flex flex-column justify-content-center align-items-start mb-xl-0 mb-3 ${styles.address_input_container}`}>
                        <div className={`mb-3 ${styles.input_header}`}>آدرس دقیق</div>
                        <input
                          type="text"
                          name="address"
                          value={fileData.address}
                          onChange={changeHandler}
                          className={`w-100 bg-light py-2 pe-3 ${styles.input}`}
                        />
                      </div>
                      {/* <div className="d-flex justify-content-center align-items-center mb-2 me-4 mt-xl-0 mt-3">
                                                <div onClick={() => setModalShow(true)} className={styles.text_primary}>
                                                    انتخاب آدرس از روش نقشه
                                                    <img className='me-2' src={arrowBlue} alt="icon" />
                                                </div>

                                            </div> */}
                    </div>
                  </div>
                </div>
                {/* address */}

                <div className="py-2 mb-3">
                  <div className="container-fluid">
                    <div
                      className={`d-flex justify-content-md-start justify-content-center flex-wrap align-items-end ${props.userAdd ? "mt-3" : "mt-3 me-3"}`}
                      dir="rtl">
                      <div
                        className={`d-flex flex-column justify-content-center align-items-start mb-xl-0 mb-3 ${
                          props.userAdd ? styles.address_input_container_user : styles.address_input_container
                        }`}>
                        <div className={`mb-3 ${styles.input_header}`}>آدرس حدودی</div>
                        <input
                          type="text"
                          name="shortAddress"
                          value={fileData.shortAddress}
                          onChange={changeHandler}
                          className={`bg-light py-2 pe-3 text-end ${styles.input_meter}`}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="py-2 mb-3">
                  <div className="container-fluid">
                    <div
                      className={`d-flex justify-content-md-start justify-content-center flex-wrap align-items-end ${props.userAdd ? "mt-3" : "mt-3 me-3"}`}
                      dir="rtl">
                      <div
                        className={`d-flex flex-column justify-content-center align-items-start mb-xl-0 mb-3 ${
                          props.userAdd ? styles.address_input_container_user : styles.address_input_container
                        }`}>
                        <div className={`mb-3 ${styles.input_header}`}>تعداد واحد در هر طبقه</div>
                        <input
                          type="number"
                          name="unitsNumber"
                          value={fileData.unitsNumber}
                          onChange={changeHandler}
                          onKeyDown={removeSymbolNumberHandler}
                          className={`bg-light py-2 pe-3 text-end ${styles.input_meter}`}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="py-2 mb-3">
                  <div className="container-fluid">
                    <div
                      className={`d-flex justify-content-md-start justify-content-center flex-wrap align-items-end ${props.userAdd ? "mt-3" : "mt-3 me-3"}`}
                      dir="rtl">
                      <div
                        className={`d-flex flex-column justify-content-center align-items-start mb-xl-0 mb-3 ${
                          props.userAdd ? styles.address_input_container_user : styles.address_input_container
                        }`}>
                        <div className={`mb-3 ${styles.input_header}`}>لینک (انتخابی)</div>
                        <input name="slug" value={fileData.slug} onChange={changeHandler} className={`bg-light py-2 pe-3 text-end ${styles.input_meter}`} />
                      </div>
                    </div>
                  </div>
                </div>

                {/* prices */}
                <div className="py-2 mb-3">
                  <div className="container-fluid">
                    <div className="d-flex justify-content-md-start justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                      <div className="d-flex flex-column justify-content-center align-items-start flex-wrap">
                        <div className={`mb-4 ${styles.title_bold}`}>
                          {categories.find(c => c.id == state?.state?.categoryId)?.dealType !== 1 ? "قیمت هرمتر و قیمت کل" : "قیمت رهن و اجاره"}
                        </div>
                        <div className="d-flex align-items-center justify-content-center flex-wrap">
                          <div className="d-flex flex-column justify-content-center align-items-start ms-md-2 mb-md-0 mb-3">
                            {categories.find(c => c.id == state?.state?.categoryId)?.dealType !== 1 ? (
                              <>
                                <div className={`mb-3 ${styles.input_header}`}>قیمت کل</div>
                                <label className="position-relative" htmlFor="totalPrice">
                                  <span className={styles.input_left_text}>تومان</span>
                                  <input
                                    type="text"
                                    name="totalPrice"
                                    value={addCommas(removeNonNumeric(fileData.totalPrice))}
                                    onChange={priceHandler}
                                    className={`bg-light py-2 ps-5 pe-2 ${styles.input_meter}`}
                                    style={{ textAlign: "right" }}
                                  />
                                </label>
                                {fileData.totalPrice ? (
                                  <span className={styles.number_farsi}>{PersianNumberToString(parseInt(fileData.totalPrice))} تومان</span>
                                ) : (
                                  <></>
                                )}
                              </>
                            ) : (
                              <>
                                <div className={`mb-3 ${styles.input_header}`}>رهن</div>
                                <label className="position-relative" htmlFor="mortgage">
                                  <span className={styles.input_left_text}>تومان</span>
                                  <input
                                    type="text"
                                    name="mortgage"
                                    value={addCommas(removeNonNumeric(fileData.mortgage))}
                                    onChange={priceHandler}
                                    className={`bg-light py-2 ps-5 pe-2 ${styles.input_meter}`}
                                    style={{ textAlign: "right" }}
                                  />
                                </label>
                                {fileData.mortgage ? (
                                  <span className={styles.number_farsi}>{PersianNumberToString(parseInt(fileData.mortgage))} تومان</span>
                                ) : (
                                  <></>
                                )}
                              </>
                            )}
                          </div>

                          <div className="d-flex flex-column justify-content-center align-items-start me-md-2 mt-md-0 mt-3">
                            {categories.find(c => c.id == state?.state?.categoryId)?.dealType !== 1 ? (
                              <>
                                <div className={`mb-3 ${styles.input_header}`}>قیمت هر متر</div>
                                <label className="position-relative" htmlFor="metrajPrice">
                                  <span className={styles.input_left_text}>تومان</span>
                                  <input
                                    type="text"
                                    name="metrajPrice"
                                    value={addCommas(removeNonNumeric(fileData.metrajPrice))}
                                    onChange={priceHandler}
                                    className={`bg-light py-2 ps-5 pe-2 ${styles.input_meter}`}
                                    style={{ textAlign: "right" }}
                                  />
                                </label>
                                {fileData.metrajPrice ? (
                                  <span className={styles.number_farsi}>{PersianNumberToString(parseInt(fileData.metrajPrice))} تومان</span>
                                ) : (
                                  <></>
                                )}
                              </>
                            ) : (
                              <>
                                <div className={`mb-3 ${styles.input_header}`}>اجاره</div>
                                <label className="position-relative" htmlFor="rent">
                                  <span className={styles.input_left_text}>تومان</span>
                                  <input
                                    type="text"
                                    name="rent"
                                    value={addCommas(removeNonNumeric(fileData.rent))}
                                    onChange={priceHandler}
                                    className={`bg-light py-2 ps-5 pe-2 ${styles.input_meter}`}
                                    style={{ textAlign: "right" }}
                                  />
                                </label>
                                {fileData.rent ? <span className={styles.number_farsi}>{PersianNumberToString(parseInt(fileData.rent))} تومان</span> : <></>}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* prices */}

                <div className="py-2 mb-3">
                  <div className="container-fluid">
                    <div className="d-flex justify-content-md-start justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                      <div className="d-flex w-100 flex-column justify-content-center align-items-start flex-wrap">
                        <div className={`mb-4 ${styles.title_bold}`}>فایل یابی از طریق</div>
                        <div className="w-100 d-flex align-items-center justify-content-start flex-wrap">
                          <RadioGroup
                            name="Radio"
                            row
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            value={fileData.fileFound}
                            onChange={changeHandler}>
                            <FormControlLabel className="mx-2" value="1" control={<Radio />} label="دیوار" />
                            <FormControlLabel className="mx-2" value="2" control={<Radio />} label="مشتری" />
                            <FormControlLabel className="mx-2" value="3" control={<Radio />} label="مشتری حضوری" />
                            <FormControlLabel className="mx-2" value="4" control={<Radio />} label="میدانی" />
                            <FormControlLabel className="mx-2" value="5" control={<Radio />} label="تراکت" />
                            <FormControlLabel className="mx-2" value="6" control={<Radio />} label="پیامک" />
                          </RadioGroup>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* files private data */}
                <div className="py-2 mb-3">
                  <div className="container-fluid">
                    <div className="d-flex justify-content-md-start justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                      <div className="d-flex w-100 flex-column justify-content-center align-items-start flex-wrap">
                        <div className={`mb-4 ${styles.title_bold}`}>اطلاعات خصوصی فایل</div>
                        <div className="w-100 d-flex align-items-center justify-content-center flex-wrap">
                          {inputValues.map((input, index) => (
                            <div className="w-100 d-flex align-items-center justify-content-md-start justify-content-center flex-wrap my-3" key={index}>
                              <div className="d-flex flex-column justify-content-center align-items-start mt-md-0 mt-3 ms-md-2 mb-md-0">
                                <div className={`mb-3 ${styles.input_header}`}>نام</div>
                                <input
                                  type="text"
                                  name="fullName"
                                  value={input.fullName}
                                  onChange={e => handleInputChange(index, e)}
                                  className={`bg-light py-2 pe-3 text-end ${styles.input_meter}`}
                                />
                              </div>
                              <div className="d-flex flex-column justify-content-center align-items-start mt-md-0 mt-3 ms-md-2 mb-md-0">
                                <div className={`mb-3 ${styles.input_header}`}>شماره تماس</div>
                                <input
                                  type="number"
                                  name="phoneNumber"
                                  value={input.phoneNumber}
                                  onChange={e => handleInputChange(index, e)}
                                  className={`bg-light py-2 pe-3 text-end ${styles.input_meter}`}
                                />
                              </div>
                              <div className="d-flex flex-column justify-content-center align-items-start mt-md-0 mt-3 ms-md-2 mb-md-0">
                                <div className={`mb-3 ${styles.input_header}`}>سمت</div>
                                <input
                                  type="text"
                                  name="responsibility"
                                  value={input.responsibility}
                                  onChange={e => handleInputChange(index, e)}
                                  className={`bg-light py-2 pe-3 text-end ${styles.input_meter}`}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="w-100 my-4 d-flex align-items-center justify-content-md-start justify-content-center">
                          <button className={`px-1 mx-2 ${styles.outline_btn}`} type="button" onClick={handleAddInputs}>
                            افزودن اطلاعات بیشتر
                            <img className="mx-2" src={addIcon} alt="icon" />
                          </button>
                          {inputValues.length > 0 && (
                            <button className={`px-1 mx-2 ${styles.filled_btn}`} type="button" onClick={handleRemoveInputs}>
                              حذف آخرین ردیف
                              <svg className="mx-2" width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M7.1228 2C7.0738 1.99986 7.02526 2.0094 6.97997 2.02809C6.93467 2.04677 6.89352 2.07423 6.85887 2.10887C6.82422 2.14352 6.79677 2.18468 6.77808 2.22997C6.7594 2.27527 6.74985 2.32381 6.75 2.37281L6.75 2.375V3.50001H11.25V2.375L11.25 2.37281C11.2501 2.32381 11.2406 2.27527 11.2219 2.22997C11.2032 2.18467 11.1758 2.14352 11.1411 2.10887C11.1065 2.07423 11.0653 2.04677 11.02 2.02809C10.9747 2.0094 10.9262 1.99986 10.8772 2L10.875 2H7.125L7.1228 2ZM3.04834 5.00001L3.93604 19.2032C3.93621 19.206 3.93637 19.2088 3.93651 19.2115C3.96245 19.7163 4.29756 20 4.6875 20H13.3125C13.6986 20 14.0322 19.7226 14.0639 19.2043L14.9517 5.00001H3.04834ZM15.7431 3.50001H12.75V2.37612C12.7506 2.12977 12.7025 1.88572 12.6086 1.65798C12.5145 1.4299 12.3763 1.22267 12.2018 1.04821C12.0273 0.873754 11.8201 0.73551 11.592 0.641429C11.3643 0.547505 11.1203 0.499446 10.874 0.500005H7.12596C6.87966 0.499446 6.63567 0.547504 6.40797 0.641429C6.17989 0.735511 5.97267 0.873756 5.79821 1.04821C5.62375 1.22267 5.48551 1.4299 5.39142 1.65798C5.2975 1.88567 5.24944 2.12966 5.25 2.37596V3.50001H2.25693C2.25279 3.49997 2.24865 3.49997 2.24451 3.50001H0.75C0.335786 3.50001 0 3.83579 0 4.25001C0 4.66422 0.335786 5.00001 0.75 5.00001H1.54541L2.43872 19.293C2.50388 20.5196 3.42898 21.5 4.6875 21.5H13.3125C14.5829 21.5 15.4868 20.5109 15.5611 19.2959C15.5611 19.2958 15.5611 19.2958 15.5611 19.2958L16.4546 5.00001H17.25C17.6642 5.00001 18 4.66422 18 4.25001C18 3.83579 17.6642 3.50001 17.25 3.50001H15.7555C15.7513 3.49997 15.7472 3.49997 15.7431 3.50001ZM5.59823 6.50048C6.01218 6.4857 6.35974 6.80929 6.37452 7.22324L6.74952 17.7232C6.76431 18.1372 6.44072 18.4847 6.02677 18.4995C5.61282 18.5143 5.26526 18.1907 5.25048 17.7768L4.87548 7.27677C4.86069 6.86282 5.18428 6.51527 5.59823 6.50048ZM12.4018 6.50048C12.8157 6.51527 13.1393 6.86282 13.1245 7.27677L12.7495 17.7768C12.7347 18.1907 12.3872 18.5143 11.9732 18.4995C11.5593 18.4847 11.2357 18.1372 11.2505 17.7232L11.6255 7.22324C11.6403 6.80929 11.9878 6.4857 12.4018 6.50048ZM9 6.50001C9.41421 6.50001 9.75 6.83579 9.75 7.25001V17.75C9.75 18.1642 9.41421 18.5 9 18.5C8.58579 18.5 8.25 18.1642 8.25 17.75V7.25001C8.25 6.83579 8.58579 6.50001 9 6.50001Z"
                                  fill="#FF2B2B"
                                />
                              </svg>
                            </button>
                          )}
                        </div>
                        {/* </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* files private data */}

                {/* upload img */}
                <Images images={images} setImages={setImages} loadedImages={loadedImages} setLoadeImages={setLoadeImages} deleteImgHandler={deleteImgHandler} />
                {/* upload img */}

                {permissions?.find(item => item === 15) === 15 && (
                  <NewFilesConsultantSelect state={userData} fileData={fileData} setFileData={setFileData} editedData={true} />
                )}

                {/* MoreFacilities */}
                <div className={`w-100 text-end px-5 my-4 pointer `}>
                  <button className={`${styles.outline_btn}`} onClick={() => setModalShow2(true)}>
                    افزودن امکانات
                    <img className="mx-2" src={addIcon} alt="icon" />
                  </button>
                </div>
                {/* MoreFacilities */}

                {/* Exchange data */}
                <div className="py-2">
                  <div className="container-fluid">
                    <div dir="rtl" className="w-100 my-4 d-flex align-items-center justify-content-md-start justify-content-center">
                      <h4 className={`mb-0 ${styles.text_primary}`}>قابل معاوضه است</h4>
                      <Checkbox
                        name="hasExchange"
                        checked={fileData.hasExchange}
                        id="checkbox"
                        onClick={ev => {
                          setFileData(prev => {
                            return { ...prev, hasExchange: !fileData.hasExchange };
                          });
                        }}
                        inputProps={{ "aria-label": "controlled" }}
                        size="medium"
                      />
                    </div>
                    {fileData.hasExchange && (
                      <div
                        className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                        dir="rtl">
                        <div className="w-100 d-flex flex-column justify-content-center align-items-start mb-4">
                          <div className={`mb-3 ${styles.input_header}`}>یادداشت</div>
                          <textarea
                            id="menuone"
                            type="text"
                            name="exchangeData"
                            className={`w-100 px-3 pt-3 ${styles.textarea}`}
                            placeholder="یادداشت خود را وارد کنید"
                            onChange={changeHandler}
                            value={fileData.exchangeData}></textarea>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/*<div className="py-2">
                                    <div className="container-fluid">
                                        {fileData.exchangeData !== null || undefined ?
                                            <div className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`} dir="rtl" >

                                                <div className='w-100 d-flex flex-column justify-content-center align-items-start mb-4'>
                                                    <div className={`mb-3 ${styles.input_header}`}>
                                                        یادداشت معاوضعه
                                                    </div>
                                                    <textarea
                                                        id='menuone'
                                                        type="text"
                                                        name="exchangeData"
                                                        className={`w-100 px-3 pt-3 ${styles.textarea}`}
                                                        placeholder="یادداشت خود را وارد کنید"
                                                        onChange={changeHandler}
                                                        value={fileData.exchangeData}
                                                    ></textarea>
                                                </div>
                                            </div>
                                            :
                                            <></>
                                        }
                                    </div>
                                </div>*/}
                {/* Exchange data */}
                {/* Description */}
                <div className="py-2">
                  <div className="container-fluid">
                    <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                      <div className="w-100 d-flex flex-column justify-content-center align-items-start mb-4">
                        <div className={`mb-3 ${styles.input_header}`}>توضیحات</div>
                        <Editor
                          tinymceScriptSrc={`${process.env.PUBLIC_URL}/assets/tinymce/tinymce.min.js`}
                          onInit={(evt, editor) => (description.current = editor)}
                          initialValue={fileData?.description}
                          init={{
                            height: 350,
                            width: "100%",
                            menubar: true,
                            resize: false,
                            directionality: "rtl",
                            plugins: [
                              "advlist",
                              "autolink",
                              "lists",
                              "link",
                              "anchor",
                              "code",
                              "charmap",
                              "preview",
                              "anchor",
                              "searchreplace",
                              "visualblocks",
                              "fullscreen",
                              "insertdatetime",
                              "table",
                              "help",
                              "wordcount",
                            ],
                            toolbar:
                              "undo redo | casechange blocks | bold italic backcolor | " +
                              "alignleft aligncenter alignright alignjustify | " +
                              "bullist numlist checklist outdent indent | removeformat | a11ycheck code table help",
                            content_style: "body { font-family:Vazir,Arial,sans-serif; font-size:14px, direction:rtl }",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Description */}

                {/* SEO DATA}
                                {userRole === "IsSuperUser" &&
                                    <div className="py-2 mb-3">
                                        <div className="container-fluid">
                                            <div
                                                className="w-100 d-flex justify-content-md-start justify-content-center flex-wrap align-items-center mt-3 me-3"
                                                dir="rtl"
                                            >
                                                <div className='w-100 d-flex flex-column justify-content-center align-items-start flex-wrap'>
                                                    <div className={`mb-4 ${styles.title_bold}`}>
                                                        اطلاعات مربوط به سئو
                                                    </div>
                                                    <div className='w-100 d-flex flex-column align-items-center justify-content-center'>
                                                        <div className='w-100 d-flex justify-content-center align-items-center ms-md-2 mb-md-0 my-2'>
                                                            <div className={`d-flex flex-column justify-content-center align-items-start ms-md-2 mb-md-0 my-2 ${styles.input__container_half}`}>
                                                                <div className={`my-3 ${styles.input_header}`}>
                                                                    seoTitle
                                                                </div>
                                                                <input
                                                                    type="text"
                                                                    name="seoTitle"
                                                                    value={fileData.seoTitle}
                                                                    onChange={changeHandler}
                                                                    className={`bg-light py-2 ps-5 pe-2 w-100 ${styles.input_meter}`}
                                                                    style={{ textAlign: "right" }}
                                                                />
                                                            </div>
                                                            <div className={`d-flex flex-column justify-content-center align-items-start ms-md-2 mb-md-0 my-2 ${styles.input__container_half}`}>
                                                                <div className={`my-3 ${styles.input_header}`}>
                                                                    seoKeywords
                                                                </div>
                                                                <input
                                                                    type="text"
                                                                    name="seoKeywords"
                                                                    value={fileData.seoKeywords}
                                                                    onChange={changeHandler}
                                                                    className={`bg-light py-2 ps-5 pe-2 w-100 ${styles.input_meter}`}
                                                                    style={{ textAlign: "right" }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className='w-100 d-flex flex-column justify-content-center align-items-start me-md-2 mt-md-0 my-2'>
                                                            <div className={`my-3 ${styles.input_header}`}>
                                                                seoDescription
                                                            </div>
                                                            <textarea name="seoDescription"
                                                                value={fileData.seoDescription}
                                                                onChange={changeHandler}
                                                                className={`bg-light py-3 ps-5 pe-3 w-100  ${styles.text__area}`}
                                                            ></textarea>
                                                        </div>

                                                        <div className='w-100 d-flex flex-column justify-content-center align-items-start me-md-2 mt-md-0 my-2'>
                                                            <div className={`my-3 ${styles.input_header}`}>
                                                                seoSchema
                                                            </div>
                                                            <textarea name="seoSchema"
                                                                value={fileData.seoSchema}
                                                                onChange={changeHandler}
                                                                className={`bg-light py-3 ps-5 pe-3 w-100  ${styles.text__area}`}
                                                            ></textarea>
                                                        </div>

                                                        <div className='w-100 d-flex flex-column justify-content-center align-items-start me-md-2 mt-md-0 my-2'>
                                                            <div className={`my-3 ${styles.input_header}`}>
                                                                seoCanonical
                                                            </div>
                                                            <input
                                                                type="text"
                                                                name="seoCanonical"
                                                                value={fileData.seoCanonical}
                                                                onChange={changeHandler}
                                                                className={`bg-light py-2 ps-5 pe-2 w-100 ${styles.input_meter}`}
                                                                style={{ textAlign: "right" }}
                                                            />
                                                        </div>

                                                        <div className='w-100 d-flex flex-column align-items-start justify-content-center mb-4'>
                                                            <div className={`my-3 ${styles.input_header}`}>
                                                                seoIndexPage
                                                            </div>
                                                            <Checkbox
                                                                checked={fileData.seoIndexPage}
                                                                id="seoIndexPage"
                                                                onClick={changeHandler}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                                size="medium"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {/* SEO DATA */}

                {/* Save Btn */}
                <div className="py-2 mb-4">
                  <div className="container-fluid">
                    <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                      <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center">
                        {btnLoader ? (
                          <div className={Dstyles.btn_loader_container}>
                            <div className={Dstyles.btn_spinner}></div>
                          </div>
                        ) : (
                          <button className={`d-flex align-items-center justify-content-center ${styles.save_btn}`} type="submit" onClick={submitHandler}>
                            ویرایش
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Save Btn */}
              </div>
            </div>

            {/* sideMenu starts */}
            <div className="col-md-3">
              <DashboardSideMenu addNewFile />
            </div>
            {/* sideMenu ends */}
          </div>
        </div>
      )}
    </>
  );

  function backHandler() {
    const data = state.pageNumber;
    history.push("/FileManagement", data);
  }

  function changeHandler(event) {
    if (event.target.name === "slug") {
      const regex = /^[A-Za-z0-9-]*$/;
      let value = event.target.value;
      value = value.replace(" ", "-");
      if (!regex.test(value)) {
        return;
      }
      setFileData(prev => {
        return { ...prev, slug: value };
      });
    } else if (event.target.name === "ownersPhone") {
      if (event.target.value === "" || event.target.value.match(/^[0-9]+$/)) {
        if (event.target.value.length <= 11) {
          setFileData(prev => {
            return { ...prev, [event.target.name]: event.target.value };
          });
        }
      }
    } else if (event.target.id === "seoIndexPage") {
      setFileData(prev => {
        return { ...prev, seoIndexPage: event.target.checked };
      });
    } else if (event.target.name === "Radio") {
      setFileData(prev => {
        return { ...prev, fileFound: event.target.value };
      });
    } else {
      setFileData(prev => {
        return { ...prev, [event.target.name]: event.target.value };
      });
    }
  }

  function priceHandler(event) {
    setFileData(prev => {
      return { ...prev, [event.target.name]: removeCommas(event.target.value) };
    });

    if (event.target.name == "totalPrice") {
      const price = removeCommas(event.target.value);
      const newPrice = price / fileData.meter;
      const firstPrice = newPrice?.toString().split(".")[0];
      const finalPrice = parseInt(firstPrice);
      setFileData(prev => {
        return { ...prev, metrajPrice: finalPrice };
      });
    }

    if (event.target.name == "metrajPrice") {
      const price = removeCommas(event.target.value);
      const newPrice = price * fileData.meter;
      const firstPrice = newPrice?.toString().split(".")[0];
      const finalPrice = parseInt(firstPrice);
      setFileData(prev => {
        return { ...prev, totalPrice: finalPrice };
      });
    }
  }

  async function deleteImgHandler(item) {
    const data = {
      imageId: item.id,
      estateId: item.estateId,
    };
    const postDeleteImg = await axios.post("Estate/removeImage", data, {
      headers: { authorization: "Bearer " + userToken },
    });
  }

  function submitHandler() {
    const inputData = fileData.seoCanonical;
    const linkRegex = /^(http|https):\/\/[^ "]+$/;
    if (inputData && !linkRegex.test(inputData)) {
      notify("باید لینک باشد seoCanonical", "error");
    } else {
      if (!Object.keys(errors).length) {
        notify("درحال ویرایش فایل", "success");
      } else {
        notify("!لطفا تمام فیلد هارا پرکنید", "error");
      }
    }
  }

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      editEstateHandler();
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  async function editEstateHandler() {
    let currentDate = new Date().toLocaleDateString("fa-IR");
    const p2e = s => s?.toString()?.replace(/[۰-۹]/g, d => "0123456789".indexOf(d));
    setBtnLoader(true);
    try {
      const {
        title,
        meter,
        room,
        floor,
        rent,
        totalPrice,
        metrajPrice,
        mortgage,
        address,
        shortAddress,
        year,
        city,
        place,
        userPhone,
        fileFound,
        exchangeData,
        unitsNumber,
        region,
        link,
        meterBase,
        meterBalkony,
        meterGate,
        landHeight,
        landWidth,
        walkawayWidth,
        ceilingHeight,
        totalFloors,
        pumpCount,
        storage,
      } = fileData;
      var data = new FormData();
      data.append("EstateId", state.state.id || "");
      data.append("UserId", fileData.fileConsultant[0]?.id ? fileData.fileConsultant[0].userId : fileData.fileConsultantID || "");
      data.append("Title", title || "");
      data.append("ConstructionDate", p2e(currentDate?.toString()) || "");
      data.append("ConstructionYear", p2e(year) || "");
      data.append("OtherSiteUrl", link ? link : "https://azrmelk.com/");
      data.append("Meterage", p2e(meter) || "");
      data.append("RoomCount", room || "");
      data.append("Floor", floor == "همکف" ? "0" : floor == "زیرزمین" ? "-1" : p2e(floor) || 0);
      data.append("RentPrice", rent ? rent : 0);
      data.append("TotalPrice", totalPrice ? totalPrice : 0);
      data.append("MeteragePrice", metrajPrice ? metrajPrice : 0);
      data.append("MortgagePrice", mortgage ? mortgage : 0);
      data.append("Description", description.current?.getContent() || "");
      data.append("CategoryId", editedData.categoryId || "");
      data.append("SubCategoryId", editedData.subCategoryId || "");
      data.append("SeoDataViewModel.MetaTitle", fileData.seoTitle ? fileData.seoTitle : "آذرملک");
      data.append("SeoDataViewModel.MetaDescription", fileData.seoDescription ? fileData.seoDescription : "آذرملک");
      data.append("SeoDataViewModel.MetaKeyWords", fileData.seoKeywords ? fileData.seoKeywords : "آذرملک");
      data.append("SeoDataViewModel.IndexPage", fileData.seoIndexPage ? fileData.seoIndexPage : false);
      data.append("SeoDataViewModel.Canonical", fileData.seoCanonical ? fileData.seoCanonical : "http://azrmelk.com/");
      data.append("SeoDataViewModel.Schema", fileData.seoSchema ? fileData.seoSchema : "آذرملک");
      data.append("MeterageBase", meterBase ? meterBase : 0);
      data.append("MeterageBalkony", meterBalkony ? meterBalkony : 0);
      data.append("MeterageGate", meterGate ? meterGate : 0);
      data.append("CommercialStorage", storage ? storage : 0);
      data.append("CeilingHeight", ceilingHeight ? ceilingHeight : 0);
      data.append("TotalFloors", totalFloors ? totalFloors : 0);
      data.append("PumpCount", pumpCount ? pumpCount : 0);
      data.append("WalkawayWidth", walkawayWidth ? walkawayWidth : 0);
      data.append("LandWidth", landWidth ? landWidth : 0);
      data.append("LandHeight", landHeight ? landHeight : 0);
      data.append("Area", "1");
      if (fileData.slug != undefined && fileData.slug != "") {
        data.append("Slug", fileData.slug || "");
      }
      data.append("Facilities", addedFacilities || "");
      if (loadedImages != "") {
        data.append("ImageFile", loadedImages == "" ? images[0].file : loadedImages[0].imageFileUrl);
      } else {
        data.append("ImageFile", images == undefined ? "" : images[0].file);
      }
      data.append("SearchType", fileFound || 1);
      data.append("UnitsNumber", unitsNumber || "");
      data.append("Commission", "1");
      data.append("ExchangeDescription", fileData.hasExchange ? fileData.exchangeData : "");
      if (typeof region === "number") {
        data.append("EstateRegion", region);
      } else {
        data.append("EstateRegion", region == "ایران" ? "1" : region == "ترکیه" ? "2" : region == "قبرس" && "3");
      }
      data.append("Address.Province", address || "");
      data.append("Address.Location", `38.0560, 46.3583`);
      data.append("Address.City", p2e(city) || "");
      data.append("Address.Zone", p2e(place) || "");
      data.append("Address.ShortAddress", p2e(shortAddress) || "");
      data.append("Address.FullAddress", p2e(address) || "");
      if (props.userAdd) {
        data.append("OwnerMobileNumber", p2e(userPhone) || "");
      }
      for (const value of inputValues) {
        data.append("EsateInfos", JSON.stringify(value) || "");
      }
      data.append("CustomKeys", "تعداد پارکینگ");
      data.append("CustomValues", parkingCount ? parkingCount : 0);
      for (const id of addedFacilitiesID) {
        data.append("Keys", id?.toString());
      }
      for (const value of addedFacilities) {
        data.append("Values", value);
      }

      if (images) {
        try {
          for (const image of images) {
            var imageData = new FormData();
            imageData.append("EstateId", state.state.id);
            imageData.append("ImageFile", image.file);
            const postImg = await axios.post("Estate/addImage", imageData, {
              headers: { authorization: "Bearer " + userToken },
            });
          }
        } catch (error) {}
      }

      const apiData = await axios.put("Estate/EditEstateForAdmin", data, {
        headers: { authorization: "Bearer " + userToken },
      });

      if (apiData.data.metaData.appStatusCode != 1) {
        notify(apiData.data.metaData.message, "error");
        return;
      }
      // console.log(apiData)
      setBtnLoader(false);
      // history.push('/FileManagement')
      history.goBack();
    } catch (error) {
      // console.log(error)
      notify("خطای سرور", "error");
    }
    setBtnLoader(false);
  }
};

export default React.memo(EditCard);
